module.exports = __webpack_public_path__ + "static/img/s27.af2076a3.png";